import { IAction } from '@Root/types'
import { IProjectVersionData } from '@SiteModules/ProjectVersion/types'
import { IStartQuickstartProcessingPayload } from '@SiteModules/Onboarding/types'
import { IUploadedElement } from '@Utils/ElementUploader'

export const ElementActionTypes = {
  CREATE_ELEMENT: '@@element/CREATE_ELEMENT',
  CREATE_ELEMENT_SUCCESS: '@@element/CREATE_ELEMENT_SUCCESS',
  CREATE_ELEMENT_FAILURE: '@@element/CREATE_ELEMENT_FAILURE',
  SUBMIT_URLS: '@@element/SUBMIT_URLS',
  SUBMIT_URLS_SUCCESS: '@@element/SUBMIT_URLS_SUCCESS',
  SUBMIT_URLS_FAILURE: '@@element/SUBMIT_URLS_FAILURE',
  FETCH_ELEMENTS: '@@element/FETCH_ELEMENTS',
  FETCH_ELEMENTS_SUCCESS: '@@element/FETCH_ELEMENTS_SUCCESS',
  FETCH_ELEMENTS_FAILURE: '@@element/FETCH_ELEMENTS_FAILURE',
  DELETE_ELEMENT: '@@element/DELETE_ELEMENT',
  DELETE_ELEMENT_SUCCESS: '@@element/DELETE_ELEMENT_SUCCESS',
  DELETE_ELEMENT_FAILURE: '@@element/DELETE_ELEMENT_FAILURE',
  RESET_SHOULD_CHECK_AUTO_FILL: '@@element/RESET_SHOULD_CHECK_AUTO_FILL',
  SET_SHOULD_CHECK_AUTO_FILL: '@@element/RESET_SHOULD_CHECK_AUTO_FILL'
}

export interface IElementState {
  readonly hasLoadedInitially: boolean
  readonly loading: boolean
  readonly deleting: boolean
  readonly elements: IElement[]
  readonly page: {
    readonly totalCount: number
    readonly totalPages: number
    readonly currentPage: number
    readonly shouldCheckAutoFill: boolean
  }
}

export interface IElement {
  readonly id: string
  readonly attributes: IElementAttributes
}

export interface ICreateElementSuccessResponseBody {
  readonly data: IProjectVersionData
}

export interface ISubmitUrlsPayload {
  readonly urls: string[]
  readonly workspaceId: number
  readonly submitUrlIdentifier: string
  readonly submittedFromChannelsPage?: boolean
}

export interface ISubmitUrlsSuccessResponseBody {
  readonly projectVersions: {
    data: IProjectVersionData[]
  }
  readonly elements: {
    data: IElementData[]
  }
}

export interface ICreateElementPayload extends IUploadedElement {
  readonly workspaceId: number
  readonly elementId: string
  readonly discardAfterCreate?: boolean
  readonly repurposing?: boolean
  readonly quickstart?: boolean
  readonly startQuickstartProcessingPayloadData?: IStartQuickstartProcessingPayload
}

export interface IElementData {
  readonly id: string
  readonly type?: 'element'
  readonly attributes: IElementAttributes
}

export interface IElementAttributes {
  readonly thumbnailUrl: string
  readonly title: string
  readonly duration: string
  readonly unformattedDuration: number
  readonly createdAt: string
  readonly updatedAt: string
  readonly kind: string
  readonly size: string
  readonly unformattedSize: number
  readonly projectIds: string[]
  readonly state: string
}

export interface IFetchElementsPayload {
  readonly page: number
  readonly workspaceId: number
}

export interface IFetchElementsSuccessResponseBody {
  readonly totalCount: number
  readonly totalPages: number
  readonly currentPage: number
  readonly data: IElementData[]
}

export interface IDeleteElementPayload {
  elementId: string
  notifyAboutSuccess?: boolean
}

export interface IDeleteElementSuccessPayload {
  elementId: string
}

export type TElementActionTypes =
  IAction<ICreateElementSuccessResponseBody> |
  IAction<ISubmitUrlsSuccessResponseBody> |
  IAction<IFetchElementsSuccessResponseBody> |
  IAction<ISubmitUrlsPayload> |
  IAction<IDeleteElementSuccessPayload>
